
import { Select } from '@walmart-web/livingdesign-components';

const LDSelect = (props:any) => {
    return <Select {...props} />
}


export default LDSelect;